import { FilterHandler } from '@btime/react-contexts'
import React from 'react'

import { useCurrentModal } from '../../../components/modals/ModalsContext'
import ControlledModal from '../../../components/modals/ControlledModal'
import FormLoader from './_load/FormLoader'
import FormSendsLoader from './_load/FormSendsLoader'
import FormSendsTable from './table/FormSendsTable'
import ModalHeader from './ModalHeader'
import Separator from '../../../components/helpers/Separator'

const FormSendsModal = props => {
  const { data: formId } = useCurrentModal()

  return (
    <ControlledModal width="42rem" {...props}>
      <FormLoader id={formId}>
        <ModalHeader />
        <Separator weight={4} />
        <FilterHandler>
          <FormSendsLoader>
            <FormSendsTable />
          </FormSendsLoader>
        </FilterHandler>
      </FormLoader>
    </ControlledModal>
  )
}

export default FormSendsModal
